import React from 'react'
import './moengage.scss'
import { Constants, ImageConstants } from '../../constants/constants'
import { getImageSource } from '../../utility/image-source'
import Loading from '../common/loading/loading'
import Urls from '../../apis/url'
import httpClient from '../../apis/http-client'
import ToasterComponent from '../common/cw-toaster-component/cw-toaster-component'

class SchoolSignupComponent extends React.Component {
  state = {
    loading: true
  }

  constructor (props) {
    super(props)
    this.state.schoolCode = props.match.params.code
    this.state.teacherId = props.match.params.id
    this.state.parentId = props.match.params.parentId
    this.state.classes = props.match.params.classes
  }

  componentDidMount () {
    const { schoolCode, teacherId, parentId, classes } = this.state
    const url = Urls.BASE_URL + Urls.SEND_PAT_NOTIFICATION
    let payload = {
      schoolCode,
      teacherId,
      classes: classes || "all"
    }
    if (parentId) {
      payload = {
        parentId,
        classes: classes || "all"
      }
    }
    httpClient
      .post(url, null, payload)
      .then(response => {
        console.log(response)
        this.setState({
          loading: false
        })
      })
      .catch(err => {
        console.log(err)
        this.showToaster('error', 'Something went wrong. Contact support')
        this.setState({
          error: true
        })
      })
  }

  showToaster (type, message) {
    this.setState(
      {
        showToaster: true,
        toasterMessage: message,
        toasterType: type
      },
      () => {
        setTimeout(() => {
          this.hideToaster()
        }, 3000)
      }
    )
  }

  hideToaster () {
    this.setState({
      showToaster: false
    })
  }

  render () {
    const { toasterMessage, toasterType, showToaster } = this.state
    return (
      <>
        <div className='container-fluid notification-component'>
          {/* {this.state.loading && <Loading />} */}
          <div className='header row no-gutters'>
            <div className='col-12 text-right'>
              <img
                alt=''
                className='header-bg'
                src={getImageSource(ImageConstants.NOTIFICATION_HEADER_BG)}
              />
            </div>
          </div>

          <div className='row'>
            <div className='col'>
              {!this.state.loading && (
                <div className='notification-container'>
                  <div className='text-center'>
                    <img
                      alt=''
                      className='notification-banner'
                      src={getImageSource(ImageConstants.NOTIFICATION_BANNER)}
                    />
                  </div>
                  <div class='notification-details'>
                    <p className='success-message'>
                      Great! We have forwarded your gesture of encouragement to
                      your students.
                    </p>
                    <p className='success-description'>
                      We respect and appreciate your dedication and support to
                      your students and hope all your students perform well in
                      the Countingwell Maths Premier League 2022 Test.
                    </p>
                    <p className='success-description'>
                      For any further assistance or to implement Countingwell's
                      acclaimed Maths learning and formative assessment platform
                      to your school without increasing your workload or your
                      students' fee burden, contact us on <br />
                      <span>schoolsupport@countingwell.com</span>
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        {showToaster ? (
          <ToasterComponent
            message={toasterMessage}
            type={toasterType}
            position='bottom-center'
          />
        ) : (
          ''
        )}
      </>
    )
  }
}

export default SchoolSignupComponent
